<template>
  <div class="container mt-2">
    <onfido-sdk-wrapper
      :profile_id="profile_id"
      :first_name="first_name"
      :last_name="last_name"
      :enterprise_id="enterprise_id"
      ref="onfido_wrapper"
      @success="onfido_success"
    />
  </div>
</template>

<script>
import {
  warning_message,
  get,
  generate_error_message_text,
  post,
  format_date,
  success_message,
  drive_static_file_url,
} from "@/utils";
import OnfidoSdkWrapper from "../../onfido/frontend/OnfidoSdkWrapper.vue";
import moment from "moment";

export default {
  name: "PersonalSavingsAccountRequestVerification",
  components: {
    OnfidoSdkWrapper,
  },
  data() {
    return {
      uuid: "",
      error: "",
      enterprise_id: "",
      profile_id: "",
      first_name: "",
      last_name: "",
      request: null,
    };
  },
  computed: {},
  methods: {
    load_request(uuid) {
      let v = this;
      v.uuid = uuid;
      v.$root.loader(true);
      get("/account-request/personal-savings/complete/onfido-settings", {
        uuid: uuid,
      })
        .then((response) => {
          let {
            first_name,
            last_name,
            profile_id,
            enterprise_id,
            flow,
            status,
          } = response;

          if (status === "onfido-completed") {
            if (flow === "capture-documentation-verification") {
              this.$router.push({
                path: `/account-request/personal-savings/process-finished`,
              });
            } else if (flow === "capture-verification-documentation") {
              this.$router.push({
                path: `/account-request/personal-savings/documentation/${this.request.uuid}`,
              });
            } else {
              v.error = v.$t("flow not recognized");
              console.error("Unknown flow", flow);
              return;
            }
          }

          v.request = response;
          v.first_name = first_name;
          v.last_name = last_name;
          v.profile_id = profile_id;
          v.enterprise_id = enterprise_id;
          v.$nextTick(() => {
            v.$refs.onfido_wrapper.init();
          });
        })
        .catch((error) => {
          console.error(error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    onfido_success(payload) {
      let v = this;
      post("/account-request/personal-savings/complete/verification", {
        uuid: v.uuid,
        onfido_request_uuid: payload.onfido_request_uuid,
      })
        .then((response) => {
          let flow = this.request.flow;
          if (flow === "capture-documentation-verification") {
            this.$router.push({
              path: `/account-request/personal-savings/process-finished`,
            });
          } else if (flow === "capture-verification-documentation") {
            this.$router.push({
              path: `/account-request/personal-savings/documentation/${this.request.uuid}`,
            });
          } else {
            console.error("Unknown flow", flow);
          }
        })
        .catch((error) => {
          console.error(error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    let uuid = this.$route.params.uuid;
    if (uuid) {
      this.load_request(uuid);
    } else {
      this.error = this.$t("invalid request id");
    }
  },
};
</script>

<style scoped></style>
